import { render, staticRenderFns } from "./liveMatchesTwoTitleDialog.vue?vue&type=template&id=22f9e5d8&scoped=true"
import script from "./liveMatchesTwoTitleDialog.vue?vue&type=script&lang=js"
export * from "./liveMatchesTwoTitleDialog.vue?vue&type=script&lang=js"
import style0 from "./liveMatchesTwoTitleDialog.vue?vue&type=style&index=0&id=22f9e5d8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f9e5d8",
  null
  
)

export default component.exports